import axios from 'axios';

import type {
  FilterOptionResponseBody,
  FilterSchemaResponseBody,
  GetDefinitionParams,
  GetFilterSchemaParams,
} from '../types/api/definition';
import type {BehaviorResponseBody} from '../types/api/settings';
import {transformations} from '../utils/transformations';
import {AXIOS_BASE_CONFIG, makeParamsConfig} from './axiosConfig';
import type {ApiContext} from './types';

export function createDefinitionApi(
  ctx: ApiContext,
  behaviorOverrides?: Partial<BehaviorResponseBody>
) {
  const BASE = `/v6/data-grid/${ctx.gridCode}`;

  return {
    getDefinition: (params?: GetDefinitionParams) =>
      axios
        .get(
          `${BASE}/definition`,
          makeParamsConfig({loadChoiceFilterOptions: params?.loadChoiceFilterOptions ?? true})
        )
        .then((response) => {
          const definition = transformations.transformDefinitionResponse(response.data);
          return {...definition, behavior: {...definition.behavior, ...behaviorOverrides}};
        })
        .catch(ctx.handleApiError),
    getColumnFilterOptions: (columnKey: string) =>
      axios
        .get<
          FilterOptionResponseBody[]
        >(`${BASE}/definition/column/${encodeURIComponent(columnKey)}/filter/options`, AXIOS_BASE_CONFIG)
        .then((response) =>
          response.data.map((option) => ({
            label: option.label,
            value: option.key,
          }))
        ),
    getFilterSchema: (params: GetFilterSchemaParams): Promise<FilterSchemaResponseBody | null> =>
      axios
        .get<FilterSchemaResponseBody>(
          `/v2/model-schema/datagrid-${ctx.gridCode}`,
          makeParamsConfig({
            recordId: params.externalFilterRecordId,
            resourceId: params.externalFilterResourceId,
          })
        )
        .then((response) => response.data)
        // A missing/failed schema must not blank the grid — swallow and yield null.
        .catch(() => null),
  };
}
